/* eslint-disable max-len */
import * as yup from 'yup';
import { Roles } from 'utils/enums';
import {
  UserFormValues,
  ReportingRoles,
  ReportingRole,
  DataEntryRoles,
  DataEntryRole,
} from './types';
import { emptyToNull, toIntOrNull } from './helper';

type Role = (typeof Roles)[keyof typeof Roles];

const REQUIRED_BURN_CENTER_ROLES: Role[] = [
  Roles.burnCenterUser,
  Roles.manager,
];

const schema: yup.ObjectSchema<UserFormValues> = yup.object({
  name: yup.string().trim().required('Name is required'),

  nickname: yup.string().transform(emptyToNull).nullable(),

  phoneNumber: yup.string().transform(emptyToNull).nullable(),

  title: yup.string().transform(emptyToNull).nullable(),

  credentials: yup.string().transform(emptyToNull).nullable(),

  email: yup
    .string().trim().email('Invalid email').matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Invalid email')
    .required('Email is required'),
  role: yup
    .mixed<Role>()
    .transform(emptyToNull)
    .oneOf(Object.values(Roles) as Role[], 'Invalid role')
    .required('Role is required'),

  burnCenterId: yup
    .number()
    .transform(toIntOrNull)
    .nullable()
    .default(null)
    .when('role', {
      is: (r: unknown) => r != null && REQUIRED_BURN_CENTER_ROLES.includes(r as Role),
      then: (s) => s.typeError('Burn Center is required').required('Burn Center is required'),
      otherwise: (s) => s.nullable().default(null),
    }),
  active: yup.boolean().required(),
  canAccessVerification: yup.boolean().required(),
  canAccessBedEntry: yup.boolean().required(),
  canUpdateTrainingContent: yup.boolean().required(),
  enableDataEntry: yup.boolean().default(false),
  enableReporting: yup.boolean().default(false),
  clinicalStudioRole: yup
    .mixed<DataEntryRole>()
    .transform(emptyToNull)
    .oneOf(([...DataEntryRoles] as const), 'Invalid data entry role')
    .nullable()
    .when('enableDataEntry', {
      is: true,
      then: (s) => s.required('Data entry role is required'),
      otherwise: (s) => s.nullable().default(null),
    }),

  reportingRole: yup
    .mixed<ReportingRole>()
    .transform(emptyToNull)
    .oneOf(([...ReportingRoles] as const), 'Invalid reporting role')
    .nullable()
    .when('enableReporting', {
      is: true,
      then: (s) => s.required('Reporting role is required'),
      otherwise: (s) => s.nullable().default(null),
    }),
});

export default schema;
